import { CloseOutlined, DeleteOutline } from '@mui/icons-material'
import { Autocomplete, Box, Button, Checkbox, Chip, Drawer, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react';

import { HttpStatusCode } from 'axios';
import { useApplicationContext } from '../../../../context/ApplicationContext';

import TemplateLoaderComponent from '../../../loader/TemplateLoaderComponent';
import useErrorHandler from '../../../../api/errorHandler/useErrorHandler';
import { LicenseDuration, PlanBilling, Severity } from '../../../../constant/ApplicationVariables';

import { createRole_API, getPermissionList_API, } from '../../../../api/controller/RolesController';
import { createLicenseAddOn_API, updateLicense_API, updateLicenseAddOn_API } from '../../../../api/controller/LicenseController';




export default function CreateAddOnLicenseComponent({ open, handleClose, handleContinue }) {
    const { handleSnackbar, currentLicenseData, setCurrentLicenseData, licenseList, setLicenseList, } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();

    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState({
        code: "",
        name: "",
        unitPrice: 0,
        chargedPerUnit: 0,
    });
    const [featuresInputText, setFeaturesInputText] = useState("");


    const [error, setError] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        validateInputs();
    }

    const handleChange = (e) => {
        if (e.target.name === "featuresInputText") {
            setFeaturesInputText(e.target.value);
        } else if (e.target.name === "active") {
            setUserData({ ...userData, [e.target.name]: e.target.checked });
        } else {
            setUserData({ ...userData, [e.target.name]: e.target.value });
        }
    }




    const validateInputs = () => {


        let errorObject = {};

        if (!userData?.code) {
            errorObject = { ...errorObject, code: "Code is required" };
        } else if (userData?.code?.length < 3) {
            errorObject = { ...errorObject, code: "Code must be at least 3 characters" };
        } else {
            delete errorObject.code;
        }

        if (!userData?.name) {
            errorObject = { ...errorObject, name: "Name is required" };
        } else if (userData?.name?.length < 3) {
            errorObject = { ...errorObject, name: "Name must be at least 3 characters" };
        } else {
            delete errorObject.name;
        }

        if (userData?.unitPrice === 0 || userData?.unitPrice === null || userData?.unitPrice === undefined) {
            errorObject = { ...errorObject, unitPrice: "Base Price is required" };
        } else if (isNaN(userData?.unitPrice) || userData?.unitPrice < 0) {
            errorObject = { ...errorObject, unitPrice: "Base Price must be a positive number" };
        } else {
            delete errorObject.unitPrice;
        }

        // if (userData?.chargedPerUnit === 0 || userData?.chargedPerUnit === null || userData?.chargedPerUnit === undefined) {
        //     errorObject = { ...errorObject, chargedPerUnit: "Charged Per Unit is required" };
        // } else if (isNaN(userData?.chargedPerUnit) || userData?.chargedPerUnit < 0) {
        //     errorObject = { ...errorObject, chargedPerUnit: "Charged Per Unit must be a positive number" };
        // } else {
        //     delete errorObject.chargedPerUnit;
        // }

        setError(errorObject);

        if (Object.keys(errorObject).length > 0) {
            return;
        }



        handleCreate();
    }


    const handleCreate = async () => {
        try {
            setLoading(true);

            let body = {
                code: userData?.code,
                name: userData?.name,
                unitPrice: userData?.unitPrice ? Number(userData?.unitPrice) : 0,
                chargedPerUnit: userData?.chargedPerUnit,
            }

            const response = await createLicenseAddOn_API(body);

            if (response) {
                errorHandler(response);
            }

            if (response.status === HttpStatusCode.Ok) {

                handleContinue();
            }


            console.log(response, "categoryreponse data")
        } catch (error) {
            console.log(error, "categoryreponse errorr")
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 100);
        }
    }



    console.log(userData, "userDatacreate error", error);
    console.log(Object.entries(LicenseDuration), "entries")

    return (
        <Drawer
            open={open}
            anchor="right"
            onClose={handleClose}
        // sx={{ "& .MuiDrawer-paper": { width: { xs: "100%", sm: "100%" } } }}
        >
            <Box className="flex flex-col w-[400px] h-full">


                {/* header */}
                <Box className="flex items-center justify-between px-4 py-2 gap-2 w-full border-b">
                    <Typography color="textPrimary">Create Add-on</Typography>

                    <IconButton onClick={handleClose}>
                        <CloseOutlined />
                    </IconButton>
                </Box>

                {/* main container */}
                <Box component={"form"} onSubmit={handleSubmit} className="flex-1 flex flex-col px-0 py-0 gap-4 relative " >
                    <Box className="flex-1 flex flex-col px-4 py-4 gap-4 relative overflow-y-auto" sx={{ gap: theme.spacing(4) }}>


                        {loading && <TemplateLoaderComponent />}

                        <FormControl required error={error?.code && error?.code}>
                            <FormLabel htmlFor="code">Code</FormLabel>
                            <TextField id="code" name="code" value={userData?.code} onChange={handleChange} error={error?.code && error?.code} helperText={error?.code && error?.code} />
                        </FormControl>

                        <FormControl required error={error?.name && error?.name}>
                            <FormLabel htmlFor="name">Name</FormLabel>
                            <TextField id="name" name="name" value={userData?.name} onChange={handleChange} error={error?.name && error?.name} helperText={error?.name && error?.name} />
                        </FormControl>


                        <FormControl required error={error?.unitPrice && error?.unitPrice}>
                            <FormLabel htmlFor="unitPrice">Price</FormLabel>
                            <TextField type="number" id="unitPrice" name="unitPrice" value={userData?.unitPrice} onChange={handleChange} error={error?.unitPrice && error?.unitPrice} helperText={error?.unitPrice && error?.unitPrice} />
                        </FormControl>

                        <FormControl required error={error?.chargedPerUnit && error?.chargedPerUnit}>
                            <FormLabel id="active-radio-group-label-charge">Charge Per Unit</FormLabel>
                            <RadioGroup
                                aria-labelledby="active-radio-group-label-charge"
                                name="chargedPerUnit"
                                value={userData?.chargedPerUnit === true ? "true" : "false"}
                                onChange={e => setUserData({ ...userData, chargedPerUnit: e.target.value === "true" })}
                                row
                                color="secondary"
                            >
                                <FormControlLabel value="true" label="Yes" control={<Radio color="secondary" />} />
                                <FormControlLabel value="false" label="No" control={<Radio color="secondary" />} />
                            </RadioGroup>
                            <FormHelperText color="error" >{error?.chargedPerUnit && error?.chargedPerUnit}</FormHelperText>
                        </FormControl>






                    </Box>


                    {/* footer */}
                    <Box className="flex items-center px-4 py-4 gap-2 w-full border-t">
                        <Button fullWidth variant="outlined" disabled={loading} onClick={handleClose}>Cancel</Button>
                        <Button type="submit" fullWidth variant="contained" color="secondary" disabled={loading} onClick={handleSubmit}>Create</Button>
                    </Box>
                </Box>

            </Box>
        </Drawer>

    )
}
